import CustomModal from "@components/Modal/Modal";
import { Grid } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import Typography from "@mv-components/Typography/Typography";
import styles from "./WarningPopupStyles";
import { useAppDispatch, useAppSelector } from "@utils/reduxUtil";
import { setWarningPopup } from "store/commonActions";
import useStyles from "@hooks/useStyle";
import MvInput from "@mv-components/MvInput";
import { InputType } from "@mv-types";

export const WarningPopup = () => {
	const dispatch = useAppDispatch();
	const { warningpopup } = useAppSelector((state) => ({
		warningpopup: state.common.warningpopup,
	}));

	const { classes, cx } = useStyles(styles) as any;

	const onCloseClick = () => {
		dispatch(setWarningPopup(false));
	};

	return (
		<>
			{warningpopup.open && (
				<CustomModal handleClose={onCloseClick}>
					<Grid
						className={cx(classes.root, classes[warningpopup.config.classNames?.root ?? ""])}
						container
						padding="24px 16px 8px 16px"
					>
						<Grid item display="flex" gap="20px">
							<WarningIcon color="warning" />
							<Typography
								className={cx(
									classes.fontSize14,
									classes[warningpopup.config.classNames?.content ?? ""]
								)}
							>
								{warningpopup?.config?.content}
							</Typography>
						</Grid>
						<Grid item display="flex" justifyContent="flex-end" width="100%" marginTop="20px">
							{warningpopup.config.actions.map((ele: any, index: number) => (
								<MvInput
									elementType={InputType.BUTTON}
									key={`${ele.label as string}${index}`}
									onClick={ele.onClick}
									className={cx(
										classes.fontSize14,
										classes[warningpopup.config.classNames?.actions?.[index] ?? ""]
									)}
									{...ele.extraProps}
								>
									{ele.label}
								</MvInput>
							))}
						</Grid>
					</Grid>
				</CustomModal>
			)}
		</>
	);
};
